import { CircularProgress as MuiCircularProgress } from "@mui/material";
import type { CircularProgressProps as MuiCircularProgressProps } from "@mui/material";

export type CircularProgressProps = Pick<
  MuiCircularProgressProps,
  "size" | "color" | "variant" | "value"
>;

export function CircularProgress(props: CircularProgressProps) {
  return <MuiCircularProgress {...props} />;
}
